// src/App.js
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Canvas, extend, useFrame } from "react-three-fiber";
import { Environment, GradientTexture, Lightformer, OrbitControls, useTexture } from "@react-three/drei";
import { Kawabun } from "../../r3f/kawabun";
import { Bloom, EffectComposer } from "@react-three/postprocessing";
import test from "../../assets/environments/potsdamer_platz_1k.hdr";
import { MathUtils, PlaneGeometry, Vector3 } from "three";
import { useInView } from "react-intersection-observer";
import WaterNormalA from "../../Water_1_M_Normal.jpeg";
import WaterNormalB from "../../Water_2_M_Normal.jpeg";
import { Water } from "three/addons/objects/Water2";
extend({Water})

const WaterWrapper = (props) => {
  const planeSize = 6
  const geo = useMemo(() => new PlaneGeometry(planeSize,planeSize), [])
  const ref = useRef()
  const waterNormalTextureA = useTexture(WaterNormalA)
  const waterNormalTextureB = useTexture(WaterNormalB)

  const options = useMemo(() => ({
    color: '#fff',
    normalMap0: waterNormalTextureA,
    normalMap1: waterNormalTextureB,
    reflectivity: 0.15,
    flowSpeed: 0.015,
    scale: 1
  }), [waterNormalTextureA,waterNormalTextureB])

  return <water {...props} ref={ref} rotation-x={-Math.PI/2} args={[geo, options]} />
}

function HeaderLogo() {

  const rendererContainer = useRef()
  const [hovered, ] = useState(false)

  const env = test;

  // Horizon lower than base to show off some of the cool sky and sun
  const horizon = 0


  // Set base parameters baby
  const [orbitControls, ] = useState(false)
  const [cameraSelect, ] = useState('start')

  // Prepped camera positions
  const cameraSelects = {
    farIntro: {
      position: new Vector3( 0, horizon, 5 ),
      target: new Vector3( 0, horizon, 0 ),
      fov: 80,
      speed: 0.5
    },
    start: {
      position: new Vector3( 0, horizon, 4 ),
      target: new Vector3( 0, 0, 0 ),
      fov: 50,
      speed: 0.5
    },
  }


  // Camera rigs
  const refOrbitControls = useRef()

  useEffect(() => {
    if (refOrbitControls.current) {
      refOrbitControls.current.enablePan = orbitControls
      refOrbitControls.current.enableRotate = orbitControls
      refOrbitControls.current.enableZoom = orbitControls
    }
  },[orbitControls])

  function CameraRig() {
    // console.log('Rendered CameraRig')

    let fov = refOrbitControls.current?.object?.fov ? refOrbitControls.current.object.fov : 60

    useFrame(({ pointer }, delta) => {
      // console.log(refOrbitControls.current)
      // console.log(delta)
      if (!orbitControls) {

        // // Camera Pan
        // const x = pointer.x * 0.01
        // const y = pointer.y * 0.005
        // refOrbitControls.current.object.translateX(x)
        // refOrbitControls.current.object.translateY(y)

        // Camera FOV Lerp
        fov = MathUtils.lerp(fov, cameraSelects[cameraSelect].fov, 0.01)
        refOrbitControls.current.object.fov = fov

        // Camera Position Lerp
        refOrbitControls.current.object.position.lerp(cameraSelects[cameraSelect].position, 0.02)
        // Camera Target Lerp
        refOrbitControls.current.target.lerp(cameraSelects[cameraSelect].target, 0.02)

        // Update the camera matrix so all above applies right
        refOrbitControls.current.object.updateProjectionMatrix()

      }

    })
  }
  const { ref, inView } = useInView()
  return (
    <div ref={ref} className="main-wrapper">
      <section className="section-3d stickies c0">
        <Canvas frameloop={inView ? 'always': 'never'} flat={true} linear={true}
                camera={{fov : 80, near : 0.1, far : 1000, position : [0, horizon, 5]}} dpr={[1, 2]}
                eventSource={rendererContainer.current} eventPrefix="client">
          <OrbitControls
            ref={refOrbitControls}
            makeDefault
            enabled={true}
            maxPolarAngle={Math.PI / 2}
            enablePan={false} // by default turn off
            enableRotate={false} // by default turn off
            enableZoom={false} // by default turn off
          />
          <CameraRig/>

          {/* <Stats /> */}

          <Environment files={env} resolution={32}>
            <group rotation={[-Math.PI / 4, -0.3, 0]}>
              <Lightformer intensity={10} rotation-y={Math.PI / 2} position={[0, 0, 4]} target={[0, 1, 1]}
                           scale={[10, 10, 10]} color={'#0E1313'}/>
              <Lightformer intensity={2} rotation-y={Math.PI / 2} position={[-3, 8, -8]} target={[0, 0, 0]}
                           scale={[10, 4, 2]} color={'#0E1313'}/>
              <Lightformer type="ring" intensity={2} rotation-y={Math.PI / 2} position={[-0.1, -1, -5]} scale={10}
                           color={'#0E1313'}/>
            </group>
          </Environment>

          <WaterWrapper position={[0, -1, 0]}/>


          {/* <group> */}
          <Kawabun rotation={[Math.PI * 0.5, 0, 0]}/>


          <GradientTexture attach="background" stops={[0, 1]} colors={['#0E1313', '#44615D']} toneMapped={false}/>

          <ambientLight intensity={0.9} color={'#eae5e0'}/>

          <directionalLight intensity={.9} position={[10, 15, -3]} color={'#44615D'}/>
          <directionalLight intensity={.9} position={[-10, 15, -3]} color={'#44615D'}/>
          <directionalLight intensity={.29} position={[20, 20, -50]} color={'#44615D'}/>
          <directionalLight intensity={.29} position={[-20, 20, -50]} color={'#44615D'}/>

          <EffectComposer>
            <Bloom kernelSize={3} luminanceThreshold={0.9} luminanceSmoothing={2} intensity={5} levels={10} mipmapBlur/>
          </EffectComposer>


        </Canvas>
      </section>
    </div>
  );
}

export default HeaderLogo;
